import React from 'react'
import { FilterName, FilterParam } from '../FilterBar.types'
import { GenericFilterDropdown } from './GenericFilterDropdown'

// A questionnaire's questions by the confidence in their answers, in its
// answer view. The options (with counts) come from the questions on the page.
export const QuestionConfidenceFilterDropdown = React.memo(
  ({ isNested = false }: { isNested?: boolean }): JSX.Element => (
    <GenericFilterDropdown
      filterParam={FilterParam.QUESTION_CONFIDENCE}
      filterName={FilterName.QUESTION_CONFIDENCE}
      valueKey="questionConfidences"
      isNested={isNested}
    />
  ),
)
